import moment from 'moment';
import { Schedule } from '../models';
import { encode } from '../utils/crypto';

export function scheduleGenerator(request: Schedule): Array<Schedule> {
  let events = [];

  // First let's check if its going to have more than one event
  const startDate = moment(request.startDateTimeUTC).add(request.duration, 'minute');
  const endDate = moment(request.endDateTimeUTC);
  const isRecurrence = !(startDate.add(request.duration, 'minutes').isSame(endDate));

  if (isRecurrence) {
    const recurrenceId = encode({
      uniqueTimeStamp: Date.now(),
      name: request.name,
      startDateTimeUTC: request.startDateTimeUTC,
      endDateTimeUTC: request.endDateTimeUTC,
    });

    // Let's generate the events for one day
    // 1. convert the start & end utc time to HH:mm
    const startTime = moment(request.startDateTimeUTC).format('HH:mm');
    const endTime = moment(request.endDateTimeUTC).format('HH:mm');
    // 2. now calculate the diff between the times, because the dates could span long times
    const numberOfDailyEvents = Math.floor(moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'), 'minutes') / request.duration);
    const dailyArray = Array.from({ length: numberOfDailyEvents }, (_, i) => {
      const minutesToAdd = request.duration * (i + 1);
      const newStartDateTime = moment(moment(request.startDateTimeUTC).add(minutesToAdd - request.duration, 'm').format()).utc();
      return {
        ...request,
        startDateTimeEpoch: newStartDateTime.valueOf(),
        startDateTimeUTC: newStartDateTime.format(),
        // new endDateTimeUTC starts from the same start date because we are generating day schedules
        endDateTimeUTC: moment(moment(request.startDateTimeUTC).add(minutesToAdd, 'm').format()).utc().format(),
        recurrenceId
      };
    });

    // Great, now let's see how many days we have, once we have that... lets just duplicate the day array adding 1 to the date
    const numberOfDaysOfEvents = moment(request.endDateTimeUTC).diff(moment(request.startDateTimeUTC), 'days') + 1;
    const dayArray = numberOfDaysOfEvents > 1
      ? Array.from({ length: numberOfDaysOfEvents }, (_, daysToAdd) => {
        return [
          ...dailyArray.map(day => {
            const newStartDateTime = moment(moment(day.startDateTimeUTC).add(daysToAdd, 'd').format()).utc();

            return {
              ...day,
              startDateTimeEpoch: newStartDateTime.valueOf(),
              startDateTimeUTC: newStartDateTime.format(),
              endDateTimeUTC: moment(moment(day.endDateTimeUTC).add(daysToAdd, 'd').format()).utc().format(),
            };
          })
        ];
      })
      : [...dailyArray];

    events = dayArray.flat();
  } else {
    events.push(request);
  }
  return events;
};

export function getStartTime(time: string | null, nextInterval: number) {
  const timeAsMoment = moment(time || moment().format('HH:mm'), 'HH:mm');
  const minutesToAdd = nextInterval - (timeAsMoment.minute() % nextInterval);

  return moment(timeAsMoment).add(minutesToAdd, 'minutes').format('HH:mm').toString();
}